module.exports = __webpack_public_path__ + "static/media/telegrotesknext-regular.117dbd49.woff";